import React, { Component } from 'react';

const ItemWithUtil = (UtilComponent, parentClass) => {
    return class ProductItemTemplate extends Component {
        formClassName = suffix => {
            return `${parentClass}__${suffix}`;
        };
        render() {
            const { formClassName } = this;
            const { product, productImage, productDescription } = this.props;
            return (
                <li className={formClassName('productItem')}>
                    <div>
                        <h3
                            className={formClassName('productTitle')}
                            dangerouslySetInnerHTML={{
                                __html: product.name
                            }}
                        />
                    </div>
                    <UtilComponent
                        parentClass={parentClass}
                        formClassName={formClassName}
                        product={product}
                        productImage={productImage}
                        productDescription={productDescription}
                    />
                </li>
            );
        }
    };
};

export default ItemWithUtil;



// WEBPACK FOOTER //
// ./src/components/ProductItem/ItemWithUtil.jsx